import * as React from "react";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";

import { logEvent } from "../../utils/Analytics";
import { SIGNUP_LINK } from "../../utils/Constants";
import { forwardUrlToApp } from "../../utils/Utils";

export interface Props {
  label?: string;
  code?: string;
  place: string;
  fullWidth?: boolean;
  textAlign?: string;
  size?: "small" | "medium" | "large";
}

export const SignupButton = (props: Props) => {
  const { label, code, place, fullWidth, textAlign, size } = props;

  const url = forwardUrlToApp(SIGNUP_LINK, { code });

  return (
    <Box textAlign={textAlign ?? "center"}>
      <Button
        variant="contained"
        color="primary"
        size={size ?? "large"}
        href={url}
        style={{ fontWeight: 700 }}
        fullWidth={fullWidth}
        onClick={() => logEvent("sign_up", { place })}
      >
        {label ?? "Sign Up Now"}
      </Button>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/SignupButton/SignupButton.tsx